'use strict';

const UserServiceImpl = require('services/UserServiceImpl');

const UserStore = {

    /**
     * Persist new User in the application.
     * @param User
     * @param {Function} success
     * @param {Function} failure
     */
    addUser(User, success, failure) {
        UserServiceImpl.createUser(User, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Change persistent User in the application.
     * @param User
     * @param {Function} success
     * @param {Function} failure
     */
    changeUser(User, success, failure) {
        UserServiceImpl.changeUser(User, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Delete Users from the application.
     * @param {Long} userId
     * @param {Function} success
     * @param {Function} failure
     */
    deleteUser(userId, success, failure) {
        UserServiceImpl.deleteUser(userId, function () {
            if (success) {
                success();
            }
        }, failure);
    },

    fetchUsers(success, failure) {
        UserServiceImpl.fetchUsers(function (users) {
            if (success) {
                success(users);
            }
        }, failure);
    }
};

module.exports = UserStore;



/** WEBPACK FOOTER **
 ** ./src/stores/UserStore.js
 **/